import { MessagePinnedByOtherEvent, MessagePinnedByYouEvent, MessageUnPinnedByOtherEvent, MessageUnPinnedByYouEvent, PartialHistoryMessageItem } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'

export const PINNED_SYSTEM_PREVIEW_MAX_LENGTH = 40

export const truncatePinnedSystemPreview = (text: string): string => {
  const normalized = text.trim()
  if (normalized.length <= PINNED_SYSTEM_PREVIEW_MAX_LENGTH) {
    return normalized
  }
  return `${normalized.slice(0, PINNED_SYSTEM_PREVIEW_MAX_LENGTH)}…`
}

export const getPinnedEventText = (
  event: PartialHistoryMessageItem<
    MessagePinnedByOtherEvent |
    MessagePinnedByYouEvent |
    MessageUnPinnedByOtherEvent |
    MessageUnPinnedByYouEvent
  >,
  options?: { isOwn?: boolean, hasPreviewText?: boolean },
): string => {
  const { t } = useLocalization()
  switch (event.item.type) {
  case 'PinnedMessageEvent': {
    if (options?.isOwn) {
      return options.hasPreviewText === false
        ? t('common.userYouPinMessageNoText')
        : t('common.userYouPinMessage')
    }
    return options?.hasPreviewText === false
      ? t('common.userPinMessageByNoText')
      : t('common.userPinMessageBy')
  }
  default: {
    return t('common.userUnPinMessageBy')
  }
  }
}

export {
  getPinnedPreview,
  getPinnedSystemQuote,
  getPinnedVoiceFileCookie,
  isPinnedVoiceFile,
} from './get-pinned-preview'
export type {
  GetPinnedPreviewOptions,
  PinnedPreview,
  PinnedPreviewIcon,
  PinnedSystemQuote,
} from './get-pinned-preview'
export {
  mapPinnedMessageToHistoryItem,
  resolvePinnedForwarding,
} from './map-pinned-message-to-history-item'
export {
  isRectEntirelyBelowViewport,
  resolveActivePinnedEventId,
} from './resolve-active-pinned-by-viewport'
export { sortPinnedNewestFirst, sortPinnedOldestFirst } from './sort-pinned-messages'
